export default __webpack_public_path__ + "static/media/020-ballet.102bbad5.svg";